const CSS = `
.react-dar-nota-skeleton{
  color:transparent !important;
  border-color:transparent !important;
  pointer-events:none;
  user-select:none;
  background-image:linear-gradient(90deg,#ececec 0%,#f7f7f7 50%,#ececec 100%);
  background-size:200% 100%;
  animation:reactDarNotaSkeletonShimmer 1.2s ease-in-out infinite;
}
@keyframes reactDarNotaSkeletonShimmer{
  0%{background-position:200% 0;}
  100%{background-position:-200% 0;}
}
`;

/**
 * Placeholder da ilha "Dar Nota" enquanto bundle e perfil carregam. Usa as
 * classes do botão real, com o texto transparente dando o tamanho natural.
 */
export default function DarNotaSkeleton() {
  return (
    <>
      <style>{CSS}</style>
      <span
        className="btn text-uppercase mt-3 react-dar-nota-skeleton"
        aria-hidden="true"
      >
        Dê sua nota
      </span>
    </>
  );
}
